import { createContext, useContext } from 'react';

import { User } from './types';

interface AuthContext {
  user: User | null;
  loading: boolean;
  getToken: () => Promise<string>;
  logOut: () => Promise<void>;
  sendEmailVerification: () => Promise<void>;
  applyActionCode: (code: string) => Promise<User | null>;
}

const defaultContextValue = Symbol();

export const AuthContext = createContext<AuthContext | typeof defaultContextValue>(
  defaultContextValue,
);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === defaultContextValue) {
    throw new Error('useAuth must be used within a AuthContextProvider');
  }
  return context;
};
